import { createGlobalStyle } from "styled-components";

export const GlobalStyles = createGlobalStyle`
  /* Theme tokens exposed to the plain CSS files, so colors live in one place
     (theme.js) and light/dark switch everywhere at once. */
  :root {
    --bg: ${({ theme }) => theme.body};
    --text: ${({ theme }) => theme.text};
    --muted: ${({ theme }) => theme.secondaryText};
    --card: ${({ theme }) => theme.projectCard};
    --accent: ${({ theme }) => theme.accentColor};
    --accent-bright: ${({ theme }) => theme.accentBright};
    --accent-contrast: ${({ theme }) => theme.accentText};
    --border: ${({ theme }) => theme.border};
    --shadow: ${({ theme }) => theme.shadow};
    --shadow-strong: ${({ theme }) => theme.shadowStrong};
  }

  *,
  *::after,
  *::before {
    box-sizing: border-box;
  }

  body {
    align-items: center;
    background: ${({ theme }) => theme.body};
    color: ${({ theme }) => theme.text};
    display: flex;
    font-family: BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
    transition: all 0.25s linear;
  }`;
